<script>
export default {
  name: "FinalDisposalManifest",
  props: {
    /**
     * マニフェスト
     */
    manifest: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {}
  },
  computed: {
    /**
     * 予約登録後365日経過によるチェックボックス無効化判定
     */
    isDisabledByExpiration() {
      return this.manifest.manifest_type === 'dxe_form' && this.manifest.old_reservation;
    }
  },
  watch: {
    isDisabledByExpiration(newValue) {
      // 365日以上経過している場合はチェックボックスをOFF
      if (newValue && this.manifest.target_for_registration) {
        this.manifest.target_for_registration = false;
        this.targetOfRegistrationChangeEvent();
      }
    }
  },
  mounted() {
    // 初期表示時に365日以上経過している場合はチェックボックスをOFF
    if (this.isDisabledByExpiration && this.manifest.target_for_registration) {
      this.manifest.target_for_registration = false;
    }
  },
  methods: {
    /**
     * チェックボックス チェンジイベント
     */
    targetOfRegistrationChangeEvent () {
      if (this.manifest.order_id) {
        this.$emit('targetOfRegistrationChange', this.manifest.order_id, this.manifest.target_for_registration)
      }
    },
    disposalItemName (itemNames) {
      if (!itemNames || itemNames.length <= 0) {
        return '-'
      } else {
        return itemNames[0]
      }
    },
  }
}
</script>

<template>
  <div>
    <h4 class="pb-3 ml-7">マニフェスト情報</h4>
    <v-row
      no-gutters
      style="flex-wrap: nowrap;"
    >
      <!-- チェックボックス -->
      <v-col
        cols="1"
        class="flex-grow-0 flex-shrink-0"
        style="margin-right: 8px;"
      >
        <div style="height: 100%;width: 100%;display: flex;align-items: center;justify-content: center;">
          <v-checkbox
            v-model="manifest.target_for_registration"
            :disabled="isDisabledByExpiration"
            dense
            @change="targetOfRegistrationChangeEvent"
            hide-details="auto"
          />
        </div>
      </v-col>
      <!-- /チェックボックス -->

      <v-col
        cols="2"
        style="min-width: 100px; max-width: 100%;"
        class="flex-grow-1 flex-shrink-0"
      >
        <dl class="manifestDescription">

          <!-- マニフェスト番号 -->
          <div>
            <dt class="text-sm-caption">マニフェスト番号</dt>
            <dd class="text-sm-caption">{{ manifest.manifest_no || '-' }}</dd>
          </div>
          <!-- /マニフェスト番号 -->

          <!-- ルート -->
          <div>
            <dt class="text-sm-caption">ルート</dt>
            <dd class="text-sm-caption">
              {{ manifest.transport_route_name }}
            </dd>
          </div>
          <!-- /ルート -->

          <!-- 排出事業者 -->
          <div>
            <dt class="text-sm-caption">排出事業者</dt>
            <dd class="text-sm-caption">
              {{ manifest.emission_name }}
              <br />
              {{ manifest.emission_location_name }}
            </dd>
          </div>
          <!-- /排出事業者 -->

          <!-- 品目 -->
          <div>
            <dt class="text-sm-caption">品目</dt>
            <dd class="text-sm-caption">
              {{ manifest.item_name }}
              <span>{{ manifest.quantity }}&nbsp;{{ manifest.quantity_unit_name }}</span>
            </dd>
          </div>
          <!-- /品目 -->

          <!-- 数量の確定者 -->
          <div>
            <dt class="text-sm-caption">数量の確定者</dt>
            <dd class="text-sm-caption">
              {{ manifest.quantity_confirm_name }}&nbsp;
            </dd>
          </div>
          <!-- /数量の確定者 -->

          <!-- 処理後物の種類 -->
          <!-- <div>
            <dt class="text-sm-caption">処理簿物の種類</dt>
            <dd class="text-sm-caption">
              {{ disposalItemName(manifest.recycle_disposed_item_name) }}
            </dd>
          </div> -->
          <!-- /処理後物の種類 -->

          <!-- 処分場処理方法 -->
          <!-- <div>
            <dt class="text-sm-caption">処分場処理方法</dt>
            <dd class="text-sm-caption">
              {{ manifest.recycle_disposer_disposal_method_name || '-' }}
            </dd>
          </div> -->
          <!-- /処分場処理方法 -->
        </dl>
      </v-col>

    </v-row>
  </div>
</template>

<style scoped lang="scss">
.manifestDescription {
  & div {
    display:flex;
    justify-content: flex-start;
    padding: 0;
  }

  & dt {
    width: 120px;
    font-weight: bold;
  }

  & dd {
    margin-left: 0;
    width: calc(100% - 120px) !important;
  }
}

</style>
